import { Service } from "@catalogue/domain/models/service.model";
import { CatalogueRepository } from "@catalogue/data/repositories/catalogue.repository";
import { Nullable } from "@core/domain/types/nullable.type";
import { inject, injectable } from "inversify";

@injectable()
export class GetServiceByIdUseCase {
    constructor(
        @inject(CatalogueRepository)
        private readonly catalogueRepository: CatalogueRepository,
    ) {}

    async execute(serviceId: number): Promise<Nullable<Service>> {
        return this.catalogueRepository.getServiceById(serviceId);
    }
}